BinderHistory = window.BinderHistory = (function () {
    var selectors = {
        hstBetTypeFilter: '#hst-bettype_filter',
    };


    var bindUI = function () {
    };

    var unBindUI = function () {
    };

    var bind = function(justLoaded) { bindUI(); }
    var unBind = function() { unBindUI(); }


    return {
        bind: bind,
        unBind: unBind,
        bindUI: bindUI,
        name: 'BinderHistory',
        url: '/History/GetViewSet'
    };
}());

//--------------------------------------------------------

ScopeHistory = window.ScopeHistory = (function () {
    var selectors = {
        mnHistCount: '#mn-hist_count'
    };


    function init() {
        app.VerticalMenu.hide();
        $(selectors.mnHistCount).removeClass('active');
    }

    function dispose() {
    }

    var start = function (justLoaded) { init(); };
    var stop = function () { dispose(); }; //TurnOff signalR before stopping pools

    return {
        start: start,
        stop: stop,
        name: 'ScopeHistory',
        title: Localization.getString('Shared.MyBets', 'Мои пари'),
        isLayoutRightColumnVisible: false
    };
}());


